import { isNode } from './environment.mjs';
import { logger } from './rollbar.mjs';

const DOWNLOAD_APP_BANNER_STORAGE_KEY = 'babbel-magazine-download-app-banner';

const getDownloadAppBannerStorage = () => {
  if (isNode()) {
    return;
  }
  try {
    // eslint-disable-next-line consistent-return -- optional return
    return JSON.parse(window.localStorage.getItem(DOWNLOAD_APP_BANNER_STORAGE_KEY));
  } catch (error) {
    logger.warn(
      'Error when trying to retrieve download app banner state from local storage',
      error,
    );
  }
};

const setDownloadAppBannerStorage = (value) => {
  if (isNode()) {
    return;
  }
  try {
    window.localStorage.setItem(DOWNLOAD_APP_BANNER_STORAGE_KEY, JSON.stringify(value));
  } catch (error) {
    logger.warn('Error when trying to set download app banner state to local storage', error);
  }
};

export { getDownloadAppBannerStorage, setDownloadAppBannerStorage };
